import React, { useState } from 'react';
import request from '@/services/request.service';
import { toFormData } from '@/utils/convert.util';
import { getServerMessage } from '@/utils/massage.util';
import { is_empty } from '@/utils/misc.util';
import { getLocaleWordContent } from '@/utils/language.util';

function InquiryWrite({ ModalActions }) {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        if (is_empty(title) || is_empty(content)) {
            alert('Please, Fill in the title, content.');
            return;
        }

        _submit(title, content);
    };

    const handleChange = (e) => {
        if (e) e.preventDefault();
        if (e.target.name === 'title') setTitle(e.target.value);
        if (e.target.name === 'content') setContent(e.target.value);
    };

    const _submit = async (title, content) => {
        const param = { title, content };
        const rsp = await request
            .post('/api/board/board_report.php', toFormData(param))
            .then((response) => response.data);
        //console.log("_submit",rsp);
        getServerMessage(rsp.msg).then((msg) => window.alert(msg));
        if (rsp.result < 0) {
        } else {
            ModalActions.showModalEx({ mode: 3 });
            return rsp;
        }
    };
    const handleClose = () => {
        ModalActions.showModalEx({ mode: 3 });
    };
    return (
        <div className="popup_01">
            <div className="popup_inner01 pop_inquiry">
                <img
                    src={require('@/resources/assets/images/close.png')}
                    className="popup_close"
                    alt="close"
                    onClick={handleClose}
                />
                <h2>
                    <div className="inner">1:1{getLocaleWordContent('문의')}</div>
                </h2>
                <div className="inner">
                    <form className="inputbox">
                        <div className="input_form">
                            <p className="title">{getLocaleWordContent('제목')}</p>
                            <input
                                type="text"
                                name="title"
                                onChange={handleChange}
                                placeholder={getLocaleWordContent('제목')}
                                className="input01"
                            />
                        </div>
                        <div className="input_form">
                            <p className="title">{getLocaleWordContent('내용입력하세요')}</p>
                            <textarea
                                name="content"
                                onChange={handleChange}
                                defaultValue={''}
                                placeholder={getLocaleWordContent('내용입력하세요')}
                            />
                        </div>
                        <div className="sub_btn_box">
                            <input type="button" onClick={handleSubmit} className="btn01" defaultValue={getLocaleWordContent('제출하기')} />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default InquiryWrite;
